import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-message-multi-tabs',
    templateUrl: './message-multi-tabs.component.html',
    styleUrls: ['./message-multi-tabs.component.scss'],
    standalone: true,
    imports: [TranslateModule, MatButtonModule]
})
export class MessageMultiTabsComponent implements OnInit {
  @Output() onClose = new EventEmitter<boolean>()
  constructor() { }
  ngOnInit() {}

  useHere(){
    this.onClose.emit(true)
  }
}
